    <template>
        <div class="promotion">
            <ul>
                <li v-for="o,index in menues" :key="index" @click="currentIndex = index" :class="{'on': currentIndex == index}">{{o.menuName}}</li>
            </ul>
            <dl v-if="menues.length > 0">
                <dd v-for="o,index in promos" :key="index" v-show="o.promotype == menues[currentIndex].promotype" @click="goPromo(o)">
                    <img :src="o.picUrl  + '/img/promopics/app/' + o.picPromo" />
                    <div>
                        <p>{{o.title}}</p>
                        <span>{{o.startTimeDesc}}</span>
                    </div>
                </dd>
            </dl>
        </div>
</template>
<script>
    import { queryPromosIe } from '../api';
    import { getStore } from "~/config/utils";
            
    export default {
        name: 'PromotionPage',
        data() {
            return {
                promos: [],
                menues: [],
                currentIndex: 0,
            }
        },
        created() {
            this.queryPromosIeAsync();
        },
        methods: {
            async queryPromosIeAsync() {
                let result = await queryPromosIe(0);
                if (!result.Message) {
                    this.menues = result.Result.promoMenues;
                    this.promos = result.Result.promoModels;
                } else {
                    this.$toast.fail(result.Message);
                }
            },
            goPromo(promo) {
            let userName = getStore("UserName");
            let token = getStore("Token");

            if (promo.bannerPromoType == 0) {
                if (promo.id == 10027 || promo.id == 10028 || promo.id == 10029 || promo.id == 10038) {
                    if (!(userName && token)) {
                        return this.$toast.fail('该优惠需要登录后方可查看');
                    }
                }

                window.open(promo.promoDescPageUrl + "&userName=" + userName + "&token=" + token);
            } else {
                if (userName && token) {
                    if(promo.id==10200){
                       this.$router.push(promo.bannerPromoPath);
                       this.$parent.handleClick(5, promo.bannerPromoPath);
                    }else{
                        window.open(promo.promoDescPageUrl + "&userName=" + userName + "&token=" + token + "&sign=1");
                    }
                } else {
                    return this.$toast.fail('该优惠需要登录后方可查看');
                }
            }
            }
        }
    }
</script>

<style scoped>
.promotion ul {
    display: flex;
    align-items: center;
    gap: 0.24rem;
}

.promotion ul li {
    width: 1.28rem;
    height: 0.56rem;
    line-height: 0.56rem;
    text-align: center;
    border-radius: 0.08rem;
    cursor: pointer;
    font-size: 0.2rem;
    background: #282828;
}

.promotion ul li.on{
    background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%);
    border-radius: 0.08rem;
    font-weight: bold;
}

.promotion dl {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    justify-content: flex-start;
    gap:0.16rem;
    margin-top: 0.24rem;
}

.promotion dl dd{
    width:4.3rem;
    height:2.74rem;
    border-radius: 0.16rem;
    overflow: hidden;
    background: #202020;
    cursor: pointer;
    transition: all 0.3s ease;
}
.promotion dl dd:hover{
transform: scale(1.03);
}


.promotion dl dd img{
width:4.3rem;
height:1.88rem;

}
.promotion dl dd div{
padding:0.16rem;
display: flex;
flex-direction: column;
gap: 0.04rem;
}
.promotion dl dd div p{
font-size: 0.2rem;
font-weight: 600;

}

    .promotion dl dd span{
    color:#999;
    }


/* ===== responsive overrides start (safe to delete) ===== */
@media screen and (max-width: 1366px) {
    .promotion ul {
        gap: 0.16rem;
    }

    .promotion dl {
        gap: 0.12rem;
    }

    .promotion dl dd,
    .promotion dl dd img {
        width: 3.3rem;
    }

    .promotion dl dd {
        height: 2.3rem;
    }

    .promotion dl dd img {
        height: 1.55rem;
    }
}

@media screen and (max-width: 1024px) {
    .promotion ul {
        flex-wrap: wrap;
    }

    .promotion dl {
        gap: 0.16rem;
    }

    .promotion dl dd,
    .promotion dl dd img {
        width: calc(50% - 0.08rem);
    }

    .promotion dl dd {
        height: auto;
    }

    .promotion dl dd img {
        height: auto;
        aspect-ratio: 430 / 188;
    }
}

@media screen and (max-width: 820px) {
    .promotion ul li {
        width: 1.08rem;
        height: 0.5rem;
        line-height: 0.5rem;
        font-size: 0.18rem;
    }

    .promotion dl dd,
    .promotion dl dd img {
        width: 100%;
    }
}
/* ===== responsive overrides end (safe to delete) ===== */


</style>